var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-label text9"},[_c('FontIcon',{staticClass:"calendar-icon",attrs:{"name":"ui_calendar"}}),_vm._v(" "+_vm._s(_vm.formatted)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }